import { useEffect } from 'react';

/**
 * Use this hook to listen to the beforeunload event.
 */
export const useOnCloseTab = (callback: (ev?: BeforeUnloadEvent) => void) => {
  useEffect(() => {
    const listener = (ev: BeforeUnloadEvent) => callback(ev);
    window.addEventListener('beforeunload', listener);
    return () => {
      window.removeEventListener('beforeunload', listener);
    };
  }, [callback]);
};
